import { FilterUsers } from 'app/main/settings/users/UsersCacheContext';
import { DateFilterItem } from 'framework/filter/date/DateFilterItem';
import { FilterBar } from 'framework/filter/FilterBar';
import { clearParams } from 'framework/utils/clearParams';
import { isFiltered } from 'framework/utils/isFiltered';
import { ICommissionPayoutsQueryParams } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';

interface IProps {
	params: ICommissionPayoutsQueryParams;
	onFilter: (params: ICommissionPayoutsQueryParams) => void;
	paddingLeft: number;
}

const exclusions: (keyof ICommissionPayoutsQueryParams)[] = [];

export const Filter = ({ params, onFilter, paddingLeft }: IProps) => {
	const strings = useLocalization();

	return (
		<FilterBar
			isFiltered={isFiltered(params, exclusions)}
			onClear={() => onFilter(clearParams(params, exclusions))}
			paddingLeft={paddingLeft}>
			<DateFilterItem
				label={strings.paidOutDate}
				after={params.payoutAfter}
				before={params.payoutBefore}
				setSelected={(after, before) => onFilter({ ...params, payoutAfter: after, payoutBefore: before })}
			/>
			<FilterUsers
				value={params.userIds}
				onChange={vals => onFilter({ ...params, userIds: vals })}
				options={{ includeBlocked: true, onlyAudiologists: false }}
			/>
		</FilterBar>
	);
};
